import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

import { SiteShell } from "@/components/site/shell";
import { DEFAULT_LANG, getDict } from "@/content/site";
import { HomePage } from "./$lang/index";

export const Route = createFileRoute("/")({
  component: RootHome,
});

function RootHome() {
  const lang = DEFAULT_LANG;
  const t = getDict(lang);
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.classList.add("im");
  }, [lang]);
  return (
    <SiteShell lang={lang} t={t}>
      <HomePage lang={lang} />
    </SiteShell>
  );
}
